const styles = {
  innerWidth: "2xl:max-w-[1280px] w-full",
  interWidth: " lg:w-[80%] w-[100%]",
  paddings: "sm:p-16 xs:p-8 px-6 py-12",
  yPaddings: "sm:py-16 xs:py-8 py-12",
  xPaddings: "sm:px-16 px-6",
  topPaddings: "sm:pt-16 xs:pt-8 pt-12",
  bottomPaddings: "sm:pb-16 xs:pb-8 pb-12",

  flexCenter: "flex justify-center items-center",
  flexStart: "flex justify-start items-start",
  flexEnd: "flex justify-end",
  navPadding: "pt-[98px]",
  //nav icons
  navIcons:
    " self-center hover:p-4 hover:bg-gray-200 hover:bg-opacity-5  rounded-[50%] duration-300",
  // hero section
  heroHeadingA:
    "font-bold lg:text-[150px] md:text-[110px] sm:text-[70px] text-[52px] lg:leading-[158.4px] md:leading-[120px] sm:leading-[80px] leading-[70px] uppercase dark:text-white text-Darktext",
  heroHeadingB:
    "font-bold lg:text-[144px] md:text-[100px] sm:text-[60px] text-[44px] lg:leading-[158.4px] md:leading-[114.4px] sm:leading-[74.4px] leading-[64.4px] uppercase dark:text-white text-Darktext",
  heroDText:
    "md:w-[212px] sm:w-[80px] w-[60px] md:h-[108px] sm:h-[48px] h-[38px] md:border-[18px] border-[9px] rounded-r-[50px] border-white sm:mx-2 mx-[6px]",
// about
  about :"mt-[8px] font-normal sm:text-[32px] text-[20px] text-center"
};

export default styles;
